import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';

const Upgrade401kModal = ({ UserDetails, enrollment}) => {
  const [showModal, setShowModal] = useState(false);
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetch401kPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPlans(data.plans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching plans!')
    })
  }, []);

  useEffect(() => {
    if (!UserDetails || !plans.length || !enrollment?.plan) return;
    const currentPlan = plans.find(
        (plan) => plan.name === enrollment.plan
    );
    if (!currentPlan || currentPlan.name === "Elite") return;
    if (Number(UserDetails.savings) > Number(currentPlan.max_savings)) {
        setShowModal(true);
    }
  }, [UserDetails.savings, enrollment.plan, plans]);
  if (!showModal) return null;

  return (
    <>
        <div><Toaster/></div>
        <div
            className="modal slide show"
            role="dialog"
            tabIndex="-1"
            aria-labelledby="staticBackdrop"
            aria-modal="true"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            >
            <div className="modal-dialog pt-5">
                <div className="modal-content mt-5 p-4" style={{ borderRadius: "1rem", backgroundColor:'#151719' }}>
                <div className="page-body">
                    <div className="head">
                    <div className="d-flex align-items-center justify-content-between mb-0">
                        <h5 className="mb-0 fw-bold text-white">Upgrade Your 401(k) Plan</h5>
                        <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowModal(false)}
                        aria-label="Close"
                        ><FontAwesomeIcon icon={faXmark} style={{color: 'white', cursor: 'pointer', fontSize: '22px'}}/></button>
                    </div>
                    <hr style={{opacity: '0.1'}}/>
                    <div className="p-3 border border-white my-4 rounded-3">
                       <p className="text-white mb-0">Your current 401(k) plan:</p>
                       <p className="my-2 text-prime text-center text-uppercase" style={{fontSize:'30px',fontWeight:'900'}}>{enrollment.plan || "Basic"}</p>
                        <p className="mb-0 text-white">
                            Upgrade now to unlock higher employer contributions, advanced
                            investment tools, and maximize your retirement savings.
                        </p>
                        <p className="mb-0 text-white mt-2 rounded-2 px-3 py-1 text-prime" style={{backgroundColor:'#ff6b3509', fontSize:'14px'}}>You’ve exceeded the maximum contribution limit for your current 401(k) plan</p>
                        <Link to="/upgradeplan" state={{route : '401k'}} className="py-2 px-3 rounded-3 mt-1 text-center fw-semibold noLink mt-3 w-100" style={{border:'2px solid #ff6b35',cursor:'pointer',fontSize:'14px'}}>Upgrade Plan</Link>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </>
  );
};

export default Upgrade401kModal;